module.exports = __webpack_public_path__ + "static/4x_itsm_onboarding_3-2f10e7bb3b907e88dc09d957e2cd37a9.png";